import { debounce } from 'lodash';

export default class BrixTable {
  static init(...parameters) {
    return new BrixTable(...parameters);
  }

  constructor(block) {
    this.wrapper = block;
    this.table = block.querySelector('table');
    block.addEventListener('scroll', debounce(() => { this.toggleFadeVisibility(); }, 10));
    window.addEventListener('resize', debounce(() => { this.toggleFadeVisibility(); }), 300);
    this.toggleFadeVisibility();
  }

  toggleFadeVisibility() {
    const wrapperClassList = this.wrapper.classList;

    // Show left fade area
    if (this.wrapper.scrollLeft > 1 && !wrapperClassList.contains('-left-fade')) {
      wrapperClassList.add('-left-fade');
    }

    // Hide left fade area
    if (this.wrapper.scrollLeft < 1 && wrapperClassList.contains('-left-fade')) {
      wrapperClassList.remove('-left-fade');
    }

    // Show right fade area
    if (this.wrapper.scrollLeft > 1 && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Show right fade area
    if (this.wrapper.scrollLeft + this.wrapper.offsetWidth
      <= this.wrapper.scrollWidth && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Hide right fade area
    if (this.wrapper.scrollLeft + this.wrapper.offsetWidth
      >= this.wrapper.scrollWidth && wrapperClassList.contains('-right-fade')) {
      wrapperClassList.remove('-right-fade');
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-table', BrixTable.init);
}
